import { faArrowLeft, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../../services/AuthService';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [sending, setSending] = useState(false);

    function onSubmit(event) {
        event.preventDefault();

        setError('');
        setSending(true);
        requestPasswordReset(email)
            .then(result => setSuccess(result.message))
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setError(
                    err.response?.status === 429
                        ? 'Too many attempts. Try again later.'
                        : err.response?.status === 422
                          ? 'Enter a valid email.'
                          : 'Could not send your request. Try again later.',
                );
            })
            .finally(() => setSending(false));
    }

    return (
        <main>
            <section className="vh-lg-100 mt-5 mt-lg-0 bg-soft d-flex align-items-center">
                <div className="container">
                    <p className="text-center">
                        <Link
                            to="/"
                            className="d-flex align-items-center justify-content-center"
                        >
                            <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="icon icon-xs me-2 my-vb-icon"
                            />
                            Back to sign in
                        </Link>
                    </p>
                    <div className="row justify-content-center form-bg-image">
                        <div className="col-12 d-flex align-items-center justify-content-center">
                            <div className="bg-white shadow border-0 rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                                <div className="text-center text-md-center mb-4 mt-md-0">
                                    <h1 className="mb-0 h3">
                                        Forgot your password?
                                    </h1>
                                    <p className="text-muted small mt-2">
                                        Enter your email and we will be told
                                        about your request.
                                    </p>
                                </div>
                                {success ? (
                                    <div className="alert alert-success">
                                        {success}
                                    </div>
                                ) : (
                                    <form action="#" onSubmit={onSubmit}>
                                        <div className="form-group mb-4">
                                            <label htmlFor="email">
                                                Your Email
                                            </label>
                                            <div className="input-group">
                                                <span className="input-group-text">
                                                    <FontAwesomeIcon
                                                        icon={faEnvelope}
                                                        className="icon icon-xs text-gray-600 my-vb-icon"
                                                    />
                                                </span>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    placeholder="example@company.com"
                                                    id="email"
                                                    value={email}
                                                    autoFocus
                                                    required
                                                    onChange={event =>
                                                        setEmail(
                                                            event.target.value,
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="d-grid">
                                            <button
                                                type="submit"
                                                className="btn btn-gray-800"
                                                disabled={sending}
                                            >
                                                Request password reset
                                            </button>
                                        </div>
                                        {error ? (
                                            <div className="alert alert-danger mt-2">
                                                {error}
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default ForgotPassword;
